<div class="row survey" *ngIf="survey$ | async as survey">
    <div *ngIf="!isSelfassessmentTab" class="m-b-25 br-0 head-component">
        <div class="col-10 m-0 p-l-20 for-fixed-component br-0 head-component card">
            <div class="col-12 pl-0 card-body">
                <div class="float-left">
                    <h5 class="m-t-10">
                        <span [routerLink]="['/user/survey-list']">
                            {{ 'lang.userMenu.mySurveys' | translate }}
                            <i class="mdi mdi-chevron-right"></i>
                        </span>
                        <span>
                            {{survey.process.name}}
                        </span>
                    </h5>
                </div>
            </div>
        </div>
    </div>
    <div class="col-9 p-l-25" *ngIf="answers$ | async as answers">
        <div class="card p-0">
            <div class="card-body base-shadow-list">
                <div class="row mb-2">
                    <h3 class="col-12">{{survey.process.name}}</h3>
                    <div class="col-12 row">
                        <div class="col-6">
                            <div class="row">
                                <div *ngIf="survey.appraisee" class="col-12">
                                    <span class="caption">{{'lang.user.appraisee' | translate}}: </span>
                                    <span class="name-user">{{survey.appraisee.name}}</span>
                                </div>
                                <div class="col-12">
                                    <span class="caption"> {{ 'lang.user.deadline' | translate}}: </span>
                                    <span>{{ getLocalizedDate(survey.endDate) }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="row">
                                <div class="col-12">
                                    <span class="caption">
                                        {{ 'lang.user.duration' | translate}}:
                                    </span>
                                    <span>
                                        {{ survey.duration }}
                                    </span>
                                    <span>{{'lang.common.minuts' | translate}}</span>
                                </div>

                                <div class="col-12">
                                    <span class="caption">
                                        {{ 'lang.user.questionsNumber' | translate}}:
                                    </span>
                                    <span>
                                        {{ survey.infrastructure.length }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="base-shadow-list" *ngFor="let category of categoriesWithQuestions" id="question-category-{{category.id}}">
            <div class="m-b-10 accordion-list">
                <accordion>
                    <accordion-group heading="{{category.name}}">
                        <app-user-question-form-selector *ngFor="let question of category.questions"
                                                         [answers]="answers"
                                                         [question]="question"
                                                         (questionAnswered)="onQuestionAnswered($event)">
                        </app-user-question-form-selector>
                    </accordion-group>
                </accordion>
                <div [ngClass]="(isPassing)?'completed-block':'d-none'">
                </div>
            </div>
        </div>
        <div>
            <span data-disabled class="save-survey float-right" (click)="completeSurvey(survey.process.id)">
                {{ 'lang.common.btn.submit' | translate }}
            </span>
            <app-thank-you-modal #thankYouModal></app-thank-you-modal>
        </div>
    </div>
    <div class="col-3 p-l-10">
        <div class="card bg-none pl-0">
            <div class="card-body  mt-2 p-0">
                <div class="row info-panel">
                    <div class="col-1">
                        <i class="mdi mdi-information-outline"></i>
                    </div>
                    <div class="col-10">
                        {{ 'lang.user.userHelp' | translate }}
                    </div>
                    <div class="parent-for col-10 m-t-40 offset-1">
                        <div class="children-for" *ngFor="let category of categoriesWithQuestions; index as i">
                            <a pageScroll href="#question-category-{{category.id}}" pageScrollOffset="150">
                                <div class="passing-list">
                                    <span class="status-passing">
                                        <i class="mdi" [ngClass]="category.isCategoryResponded?'mdi-check-circle':'mdi-minus-circle-outline'">
                                        </i>
                                    </span>
                                    <span>{{ category.name }}</span>
                                </div>
                                <div class="vline">
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>